import { useRouter } from 'next/router';
import { useAppContext } from 'Context/ReactAppContext';
import URI from 'urijs';
export const useCurrentUri = () => {
  const { asPath } = useRouter();
  const { originalUrl } = useAppContext();
  const origin = new URI(originalUrl);
  return new URI(asPath).origin(origin);
};
